export const notificationMigrations = [
  {
    id: '042_notification_delivery_settings',
    sql: `
      ALTER TABLE user_notifications ADD COLUMN IF NOT EXISTS available_at TIMESTAMPTZ NOT NULL DEFAULT NOW();

      ALTER TABLE user_notifications DROP CONSTRAINT IF EXISTS user_notifications_type_check;
      ALTER TABLE user_notifications ADD CONSTRAINT user_notifications_type_check CHECK (type IN (
        'engagement_request','engagement_decision','photo_request','photo_decision',
        'meeting_proposed','meeting_confirmed','meeting_cancelled','schedule_confirmed','call_ready',
        'support_appointment','support_updated','payment_reviewed','guardian_reviewed'
      ));

      CREATE TABLE notification_settings (
        type TEXT PRIMARY KEY,
        enabled BOOLEAN NOT NULL DEFAULT TRUE,
        delay_minutes INTEGER NOT NULL DEFAULT 0 CHECK (delay_minutes BETWEEN 0 AND 1440),
        updated_at TIMESTAMPTZ NOT NULL DEFAULT NOW(),
        updated_by UUID REFERENCES users(id) ON DELETE SET NULL
      );
      INSERT INTO notification_settings (type) VALUES
        ('engagement_request'),('engagement_decision'),('photo_request'),('photo_decision'),
        ('meeting_proposed'),('meeting_confirmed'),('meeting_cancelled'),('schedule_confirmed'),
        ('call_ready'),('support_appointment'),('support_updated'),('payment_reviewed'),
        ('guardian_reviewed')
      ON CONFLICT (type) DO NOTHING;
    `,
  },
] as const;
